import { z } from "@eisox/zod";
import { useSelector } from "@tanstack/react-form";

import { useFieldContext } from "./form.context";

const toFieldErrorMessages = (errors: unknown) => (errors as z.core.$ZodIssue[]).map(issue => issue.message);

const useFieldErrors = () => {
  const field = useFieldContext();
  return useSelector(field.store, state => toFieldErrorMessages(state.meta.errors));
};

export { toFieldErrorMessages, useFieldErrors };
